import { Box } from '@common-fe/common-fe';
import styled, { keyframes } from 'styled-components';

const widgetAppear = keyframes`
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 1; transform: translateY(0); }
`;

export const PreviewWrapper = styled(Box)`
  position: fixed;
  top: 96px;
  right: 24px;
  bottom: 24px;
  width: 480px;
  max-width: calc(100vw - 36px);
  border-radius: ${({ theme }) => theme.rounds.moduleRound};

  background: ${({ theme }) => theme.colors.canvas};

  display: flex;
  flex-direction: column;
  z-index: 102;
  box-sizing: border-box;
  overflow: hidden;
  transform-origin: bottom right;
  animation: ${widgetAppear} 250ms cubic-bezier(0.5, 0.01, 0.1, 1) forwards;

  [data-testid='zoom-button'] {
    visibility: hidden;
    pointer-events: none;
  }

  [data-testid='document-preview-scroll-container'] {
    flex: 1;
    min-height: 0;
  }

  @media (max-width: 767px) {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    border-radius: 0;
  }
`;

export const MainBody = styled(Box)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

export const ScanWrapper = styled(Box)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacings.spacing12};

  > div {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
`;

export const CloseButton = styled.button`
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.rounds.checkboxRound};
  background: ${({ theme }) => theme.colors.background3};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacings.spacing6};

  &:hover {
    background: #2d3340;
  }
  svg {
    display: block;
    width: 24px;
    height: 24px;
  }

  @media (max-width: 767px) {
    width: 32px;
    height: 32px;
    padding: ${({ theme }) => theme.spacings.spacing4};

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;
